import React, { useState, useEffect, useRef } from 'react'
import { Select, Input, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

import { SelectType } from './index'
import SearchProduct from './SearchProduct'
import axios from 'Utils/axios'

export type props<T> = {
  options: {
    value: T
    label: string
    tooltip?: string
    sub_options: { value: T; label: string }[]
  }[]
  onChange: ({
    option,
    sub_option,
    deep_link,
  }: {
    option: T
    sub_option: string
    deep_link: string
  }) => void
  value: SelectType<string | number>
}

const DependentSelect: React.FC<props<string | number>> = ({ options, onChange, value }) => {
  const firstRun = useRef(true)
  const [option, setOption] = useState(value?.option || options[0].value || '')
  const [sub_option, setSubOption] = useState(value?.sub_option || '')
  const [deep_link, setDeepLink] = useState(value?.deep_link || '')
  const handleSearchDeeplink = async (value: string) => {
    const res = await axios.get('/channels/deeplinks', {
      params: {
        product_barcode: value,
      },
    })
    setDeepLink(res?.data?.filter((item) => item?.name === 'Product Detail')?.[0]?.deeplink)
  }
  useEffect(() => {
    onChange({ option, sub_option, deep_link })
  }, [])
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false
      return
    }
    onChange({ option, sub_option, deep_link })
  }, [option, sub_option, deep_link])

  useEffect(() => {
    if (value?.deep_link) {
      setDeepLink(value?.deep_link)
    }
  }, [value?.deep_link])

  const sub_options_selects = options?.find((opt) => opt.value === option)?.sub_options

  return (
    <div className="flex gap-2 mb-2 flex-col w-full">
      <div>
        <div className=" text-secondary_text mb-1">Type button</div>
        <div className="flex">
          {options.map((item) => (
            <div
              style={{ height: 40 }}
              onClick={() => {
                setOption(item.value)
              }}
              className={`${item.value === option ? 'toggle-selected' : ''} toggle`}
              key={item.value}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
      <div className="flex-1">
        <div className=" text-secondary_text mb-1">Navigate to</div>
        <div className="flex gap-2">
          <Select
            disabled={deep_link && sub_option !== 'product_detail' ? true : false}
            placeholder="Select"
            value={sub_option || undefined}
            onChange={(value) => {
              setSubOption(value)
              setDeepLink('')
            }}
            options={sub_options_selects}
            allowClear
            style={{ width: '100%' }}
          />
          <SearchProduct
            onChange={handleSearchDeeplink}
            disabled={sub_option === 'product_detail' ? false : true}
          />
        </div>
        <div className="mt-2">
          <Input
            style={{ width: '100%' }}
            disabled={sub_option && sub_option !== 'product_detail' ? true : false}
            placeholder="Paste URL Link"
            value={deep_link || undefined}
            onChange={(e) => setDeepLink(e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}

export default DependentSelect
